<template>
  <div style="margin-top: 86px">
    <div class="contact-top">
      <div style="margin: 0px 100px;position: relative">
        <el-image
          style="height: 500px;width: 600px;position: absolute"
          :src="require('../../assets/image/contact/contact_us_2.jpg')"
          fit="contain"></el-image>
        <div class="contact-top-cover">
          <div class="contact-top-title">
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 30px; margin-bottom: 30px;">
      <div class="contact-info">
        <p>
          <strong>
            U Vigor Health Medical Technology Co., Ltd
          </strong>
        </p>
        <div>
          <i class="el-icon-location-outline" style="color: #ff0000; margin-right: 5px"></i>
          ADDRESS: No. 4, Shanxian Road, Gongshu District, Hangzhou City, Zhejiang Province, China
        </div>
        <div>
          <i class="el-icon-phone" style="color: #ff0000; margin-right: 5px"></i>
          TEL: +86-193-5708-8711
        </div>
        <div>
          <i class="el-icon-message" style="color: #ff0000; margin-right: 5px"></i>
          Email: info@uvigorhealth.com
        </div>
        <div>
          <i class="el-icon-s-home" style="color: #ff0000; margin-right: 5px"></i>
          Web: http://www.uvigorhealth.com
        </div>
      </div>

      <div class="contact-content">
        <el-form :model="sendInfo" :rules="rules" ref="sendInfoForm">
          <div class="contact-input">
          <span class="contact-input-label">
            YOUR NAME:
          </span>
            <el-form-item prop="contactName" style="width: 100%">
              <el-input v-model="sendInfo.contactName" placeholder="Required*"></el-input>
            </el-form-item>
          </div>
          <div class="contact-input">
          <span class="contact-input-label">
            TELEPHONE:
          </span>
            <el-form-item prop="contactTel" style="width: 100%">
              <el-input v-model="sendInfo.contactTel" placeholder="Required*"></el-input>
            </el-form-item>
          </div>
          <div class="contact-input">
          <span class="contact-input-label">
            E-MAIL:
          </span>
            <el-form-item prop="contactEmail" style="width: 100%">
              <el-input v-model="sendInfo.contactEmail" placeholder="Required*"></el-input>
            </el-form-item>
          </div>
          <div class="contact-input">
          <span class="contact-input-label">
            COMPANY NAME:
          </span>
            <el-form-item prop="contactCompany" style="width: 100%">
              <el-input v-model="sendInfo.contactCompany" placeholder=""></el-input>
            </el-form-item>
          </div>
          <div class="contact-input">
          <span class="contact-input-label">
            COUNTRY:
          </span>
            <el-form-item prop="contactCountry" style="width: 100%">
              <el-input v-model="sendInfo.contactCountry" placeholder=""></el-input>
            </el-form-item>
          </div>
          <div class="contact-input">
          <span class="contact-input-label">
            COMMENTS:
          </span>
            <el-form-item prop="contactComment" style="width: 100%">
              <el-input v-model="sendInfo.contactComment" type="textarea" :rows="5" placeholder="Required*"></el-input>
            </el-form-item>
          </div>
          <div class="contact-button">
            <el-button @click="send" type="primary">Send</el-button>
            <el-button @click="reset">Reset</el-button>
          </div>
        </el-form>
      </div>

    </div>
  </div>
</template>

<script>
export default {

  name: 'ContactUs',
  data() {
    return {
      sendInfo:{
        contactName: null,
        contactTel: null,
        contactEmail: null,
        contactCompany: null,
        contactCountry: null,
        contactComment: null
      },
      rules: {
        contactName: [{required: true, message: 'Input your name please.', trigger: 'blur'}],
        contactTel: [{required: true, message: 'Input your tel please.', trigger: 'blur'}],
        contactEmail: [{required: true, message: 'Input your email please.', trigger: 'blur'},
          {type: 'email', message: 'Input right email please.', trigger: 'blur'}],
        contactComment: [{required: true, message: 'Input your comments please.', trigger: 'blur'}]
      }
    }
  },
  methods: {
    send(){
      if(this.sendInfo){
        this.$refs['sendInfoForm'].validate(valid => {
          if (valid) {
            this.postRequest("/contact/send", this.sendInfo).then(resp => {
              if (resp) {
                this.reset();
              }
            })
          }else {
            return false;
          }
        });
      }
    },
    reset(){
      this.sendInfo = {
        contactName: null,
        contactTel: null,
        contactEmail: null,
        contactCompany: null,
        contactCountry: null,
        contactComment: null
      };
    }
  }
}
</script>


<style src="../../assets/css/contactUs.css" scoped>


</style>
